export default __webpack_public_path__ + "images/71556476f3b6639e57491813b3f93d74-alumni.webp";